// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.A6fybGw_lMkC5Di3IVR0{background-color:var(--background-primary-inverted-primary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `A6fybGw_lMkC5Di3IVR0`
};
export default ___CSS_LOADER_EXPORT___;
